import { FunctionComponent } from 'react'
import React from 'react'
import useRouter from '@/utils/Router'

import ProductInfo from './ProductInfo'
import ProductItems from '@/app/products/ProductItems'

import ImageWithLoader from '@/components/UiElements/ImageWithLoader'
import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import { ProductData } from '@/types/product'
import { snapshot } from 'valtio'
import store from '@/store'

type ProductListItemProps = {
	product: any
	className?: string
	url?: string
	onDelete?: (product: ProductData) => void
}


const ProductListItem: FunctionComponent<ProductListItemProps> = ({ product, className = '', url, onDelete }) => {

	const router = useRouter()
	const handleDeleteItem = () => {
		if (onDelete) onDelete(product)
	}
	return (
		<div
			onClick={() => {
				const { companySetting } = snapshot(store)

				if (companySetting?.profile_version === 'v2') {
					router.push(`/products/v2/${product['sku']}`)
				} else {
					if (url) {
						router.push(url)
					} else if (product.is_bundle) {
						router.push(`/products/bundle/${product['sku']}`)
					} else {
						router.push(`/products/sku/${product['sku']}`)
					}
				}
				return

			}}
			id={product.product_id}
			className={`relative group active:bg-gray-100 flex py-sm  border-b-gray-200 border-b-[1px] items-center hover:bg-gray-50 cursor-pointer transition-all group gap-xl px-md h-[120px] ${className} ` +
				`${product.commerce_status === 'removed' ? 'bg-red-50 hover:bg-red-100' : ''} ` +
				`${product.commerce_status === 'draft' ? 'opacity-50 hover:opacity-100' : ''} `}
		>
			{onDelete && <DeleteAbsoluteButton onClick={handleDeleteItem} className={'!top-[8px] !right-0'} />}

			<div
				className="!w-[100px] h-[100px] max-h-[100px] overflow-hidden flex flex-row justify-center items-center rounded-md min-w-[100px] mr-lg mix-blend-multiply">
				<ImageWithLoader src={product['2d_image_url']} alt={product['name']} className="!w-full !h-full mx-h-[100%]" cache={true} />
			</div>


			<div className={' flex flex-col justify-between f-full gap-md items-start transition-all h-[90px] w-full mix-blend-multiply'}>


				<div
					className={`text-title-md pl-md transition-all ${product.product_profile_id ? '' : 'text-gray-400 group-hover:text-gray-700'}`}>
					{product.name}
				</div>


				<div className={'flex flex-row gap-sm justify-between w-full '}>
					<div className={'flex flex-row gap-sm'}>
						<ProductInfo product={product} />
					</div>
					<div className={'pl-md'}>
						{(product?.sections?.length > 0 && !product.is_bundle) &&
                          <ProductItems items={product.sections.map((s: any) => s?.section_name)} />
						}
						{(product?.is_bundle) &&
							<ProductItems
								items={
									product?.bundle?.items?.map((s: any, index: number) =>
										<div className={'relative'} key={index}>
											{s.product_profile_id ?
												<div className={'font-icon-solid absolute top-[-1px] right-[-2px] bg-primary-500 text-white rounded-full w-[15px] h-[15px] text-[10px] flex justify-center items-center z-[2]'}></div>
												:
												<div className={'font-icon-solid absolute top-[-1px] right-[-2px] bg-red-500 text-white rounded-full w-[15px] h-[15px] text-[10px] flex justify-center items-center z-[2]'}>X</div>

											}

											<ImageWithLoader src={s['2d_image_url']} alt={s['name']} className="w-[42px] h-[42px] object-cover" cache={true} />

										</div>,
									)
								}
								label={null}
								className={`${product?.bundle?.items?.length ? ' !px-xs ' : ' bg-red-50 border-red-600'}`}
								emptyLabel={'No Bundle Item assigned'}
							/>
						}
					</div>
				</div>


			</div>


		</div>
	)
}

export default ProductListItem

